module.exports = __webpack_public_path__ + "static/img/viral_18.ca2abfa5.jpg";